import {
  AccessTimeOutlined,
  PersonOutline,
  UpdateOutlined,
  HistoryOutlined,
  PinDropOutlined,
  Description,
  Code,
  PublicOutlined,
  Public,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import React from "react";
import { localizeDateTimeMed } from "utils/dateFormats";
import ReactHtmlParser from "html-react-parser";
import { useRegionDetailContext } from "contexts/LocationContexts/RegionDetailContext";

const RegionBasicDetails = () => {
  const { regionDetail, loadingDetail } = useRegionDetailContext();

  return !loadingDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <InformationTile
                  icon={() => <Public color="primary" />}
                  title="Country"
                  subtitle={regionDetail?.country?.name}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  title="Province Name"
                  icon={() => <PublicOutlined color="primary" />}
                  subtitle={regionDetail?.name || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Province Code"
                  icon={() => <Code color="primary" />}
                  subtitle={regionDetail?.code || "N/A"}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  icon={() => <PinDropOutlined color="primary" />}
                  title="Coordinates"
                  subtitle={
                    regionDetail?.coordinates &&
                    regionDetail.coordinates.lat != null &&
                    regionDetail.coordinates.long != null
                      ? `${regionDetail.coordinates.lat}, ${regionDetail.coordinates.long}`
                      : "N/A"
                  }
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  title="Added By"
                  icon={() => <PersonOutline color="primary" />}
                  subtitle={regionDetail?.addedUser?.name || "N/A"}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccessTimeOutlined color="primary" />}
                  title="Created At"
                  subtitle={localizeDateTimeMed(regionDetail?.createdAt)}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <UpdateOutlined color="primary" />}
                  title="Updated At"
                  subtitle={localizeDateTimeMed(regionDetail?.updatedAt)}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HistoryOutlined color="primary" />}
                  title="Status"
                >
                  <div
                    className={`uppercase ${
                      regionDetail?.status === "Active"
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {regionDetail?.status}
                  </div>
                </InformationTile>
              </Grid>

              {regionDetail?.description && (
                <Grid item md={12}>
                  <InformationTile
                    icon={() => <Description color="primary" />}
                    title="Description"
                    subtitle={ReactHtmlParser(regionDetail?.description)}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default RegionBasicDetails;
